import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Shield, FileText, Calculator } from 'lucide-react';

const currentYear = new Date().getFullYear();

export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4">Cal-Spec Fire Alarm</h3>
            <p className="text-sm mb-4">
              Professional fire alarm system design and engineering services. 
              NFPA 72 compliant calculations and AI-enhanced plan reviews.
            </p>
            <div className="flex items-center space-x-2 text-sm">
              <Shield className="w-4 h-4 text-green-500" />
              <span>Licensed Engineer • LA County</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/services" data-testid="footer-services" className="hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/tools" data-testid="footer-tools" className="hover:text-white transition-colors">
                  Calculation Tools
                </Link>
              </li>
              <li>
                <Link to="/resources" data-testid="footer-resources" className="hover:text-white transition-colors">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/pricing" data-testid="footer-pricing" className="hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/quote" data-testid="footer-quote" className="hover:text-white transition-colors">
                  Request Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Tools */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Calculators</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/battery-calculator" className="hover:text-white transition-colors flex items-center">
                  <Calculator className="w-4 h-4 mr-2" />
                  Battery Calculator
                </Link>
              </li>
              <li>
                <Link to="/loop-load-calculator" className="hover:text-white transition-colors flex items-center">
                  <Calculator className="w-4 h-4 mr-2" />
                  Loop Load Calculator
                </Link>
              </li>
              <li>
                <Link to="/device-database" className="hover:text-white transition-colors flex items-center">
                  <FileText className="w-4 h-4 mr-2" />
                  Device Database
                </Link>
              </li>
              <li>
                <Link to="/code-references" className="hover:text-white transition-colors flex items-center">
                  <FileText className="w-4 h-4 mr-2" />
                  NFPA 72 References
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center">
                <Phone className="w-4 h-4 mr-2 text-blue-400" />
                <a href="tel:8185338313" className="hover:text-white transition-colors">
                  (818) 533-8313
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="w-4 h-4 mr-2 text-blue-400" />
                <a href="mailto:info@cal-spec.com" className="hover:text-white transition-colors">
                  info@cal-spec.com
                </a>
              </li>
              <li className="flex items-start">
                <MapPin className="w-4 h-4 mr-2 mt-0.5 text-blue-400" />
                <span>Los Angeles County, CA</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <p>&copy; {currentYear} Cal-Spec Fire Alarm. All rights reserved.</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/contact" className="hover:text-white transition-colors">
                Contact
              </Link>
              <span className="text-slate-600">|</span>
              <span className="text-slate-500">NFPA 72 • NEC 760 • IBC-IFC Compliant</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
